var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutctashap1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 160,
    viewBox: "0 0 159 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Highlight Sparkle",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M108.491 116.871C107.802 118.567 108.067 125.246 108.809 126.2C109.922 127.578 111.989 127.312 112.36 125.775C113.526 121.058 110.028 113.002 108.491 116.871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M50.8265 51.4163C50.5085 53.7482 50.6676 59.7902 50.7736 63.3942C50.8266 64.5072 51.6745 65.3552 52.7345 65.4612C55.8086 65.7262 56.4446 59.8962 54.4836 50.3033C54.0066 47.9183 51.2505 48.7133 50.8265 51.4163Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M63.1232 46.4872C67.6812 46.4872 70.2252 45.7983 70.2252 44.5263C70.2252 42.8833 66.4092 42.4592 60.6852 43.3602C54.5372 44.4202 56.1802 46.4872 63.1232 46.4872Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M50.7221 23.0078C49.4501 23.5378 49.8211 39.9677 51.0931 40.6567C54.5912 42.5117 56.1282 40.4449 55.7042 34.7209C54.6972 22.7959 54.2202 21.5768 50.7221 23.0078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M40.2273 43.2542C36.6763 43.6782 35.7754 44.049 35.7754 45.162C35.7754 46.911 46.3754 47.335 48.8664 45.692C51.8344 43.731 47.2233 42.4062 40.2273 43.2542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M109.075 109.981C110.029 109.875 110.771 109.133 110.771 108.179C111.036 101.925 111.248 97.7907 107.379 99.3277C106.637 99.6457 106.478 103.568 107.061 107.702C107.432 110.087 107.485 110.14 109.075 109.981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M113.262 112.26C111.619 112.949 111.778 114.22 113.58 114.591C115.17 114.962 121.424 114.062 122.643 113.32C124.869 111.889 116.442 110.935 113.262 112.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M106 112.207C104.304 111.571 103.933 111.571 101.23 112.366C97.1489 113.585 98.8449 115.228 103.562 114.592C106.848 114.168 108.014 113.002 106 112.207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M99.8528 87.2437C101.178 85.0177 100.754 82.2087 98.8988 80.4597C94.2878 76.1137 89.8358 68.6937 87.2388 61.0087C85.7548 56.7157 81.8328 39.4909 81.8328 37.3179C81.8328 34.5619 78.8118 33.1837 76.9038 35.0917C76.4798 35.5157 75.9498 37.3709 75.7908 39.2259C74.7838 48.5539 69.2718 69.7007 66.1448 76.0607C64.6078 79.1877 61.4278 82.2087 58.0888 83.6927C55.2268 84.9647 55.2268 85.1767 58.7778 88.2507C65.8268 94.3987 71.0208 106.536 74.6778 125.51C77.9638 142.523 83.7408 137.011 83.1048 133.566C81.7798 126.888 89.5708 104.469 98.4748 89.5227L99.8528 87.2437ZM93.0688 85.0707C87.9278 91.6427 82.3628 101.925 79.7128 109.822L78.4938 113.532L77.8048 110.087C72.9818 86.7137 63.1768 85.5477 62.1168 84.5407C63.2828 83.3217 73.8298 76.6967 78.7058 61.4327C80.1898 56.8217 79.9248 56.8217 81.3558 61.1677C84.0588 69.3827 87.8218 76.0607 92.1678 80.5127L94.6588 83.0567L93.0688 85.0707Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutctashap1);
export default __webpack_public_path__ + "static/media/aboutctashap-1.3500f65563709450def2dd0bcdc559f4.svg";
export { ForwardRef as ReactComponent };